var _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _g4, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureEventsHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b3b3b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.18 8.24h.65v1.81a.14.14 0 01-.14.14H9a.14.14 0 01-.14-.14V8.53a.29.29 0 01.32-.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18 8.24h.65v1.81a.14.14 0 01-.14.14H9a.14.14 0 01-.14-.14V8.53a.29.29 0 01.32-.29z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.56 8.24h.65a.29.29 0 01.29.29v1.53a.14.14 0 01-.14.14h-.66a.14.14 0 01-.14-.14V8.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.56 8.24h.65a.29.29 0 01.29.29v1.53a.14.14 0 01-.14.14h-.66a.14.14 0 01-.14-.14V8.24z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.5v.63H8.9V8.5a.29.29 0 01.29-.29h8a.29.29 0 01.31.29z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#b3b3b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 14h.65a.14.14 0 01.14.14v1.81h-.61a.29.29 0 01-.29-.29v-1.55A.14.14 0 019 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14h.65a.14.14 0 01.14.14v1.81h-.61a.29.29 0 01-.29-.29v-1.55A.14.14 0 019 14z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 14h.65a.14.14 0 01.14.14v1.53a.29.29 0 01-.29.29h-.65v-1.85a.14.14 0 01.15-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 14h.65a.14.14 0 01.14.14v1.53a.29.29 0 01-.29.29h-.65v-1.85a.14.14 0 01.15-.11z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 15.67v-.63h8.61v.63a.29.29 0 01-.29.29h-8a.29.29 0 01-.32-.29z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.09 11.74a.13.13 0 01-.11.13H13a.12.12 0 01-.13-.12V11a.14.14 0 01.11-.13h1a.12.12 0 01.13.12z",
    fill: "#76bc2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 12.5a.13.13 0 01-.11.13h-1a.12.12 0 01-.13-.12v-.74a.11.11 0 01.11-.12h1a.11.11 0 01.13.11zM14.09 13.26a.12.12 0 01-.11.13H13a.12.12 0 01-.13-.11v-.75a.12.12 0 01.13-.13h1a.11.11 0 01.13.11v.75z",
    fill: "#5e9624"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 11a.11.11 0 01-.11.12h-1A.11.11 0 0111 11v-.77a.11.11 0 01.11-.12h1c.1 0 .15.05.15.12z",
    fill: "#86d633"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5a.12.12 0 01-.11.13h-1a.12.12 0 01-.12-.12v-.76a.12.12 0 01.11-.13h1c.1 0 .15.05.15.13z",
    fill: "#76bc2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 14a.11.11 0 01-.11.13h-1A.12.12 0 0111 14v-.78a.12.12 0 01.11-.13h1a.13.13 0 01.15.13z",
    fill: "#5e9624"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#949494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.31 5.8a.28.28 0 00-.31-.28H5a.28.28 0 00-.29.28v1.53a.15.15 0 00.15.14h.64a.14.14 0 00.14-.14v-.9h6.72v.9a.15.15 0 00.15.14h.65a.15.15 0 00.15-.14V5.8zM5.64 11.32a.14.14 0 00-.14-.14h-.65a.15.15 0 00-.15.14v1.53a.25.25 0 00.21.28h3.48v-.91H5.64z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#949494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11 2.36a.29.29 0 00-.29-.29h-8a.29.29 0 00-.29.29v1.53A.14.14 0 00.64 4h.66a.14.14 0 00.14-.14V3h6.72v.91a.15.15 0 00.15.09H9a.15.15 0 00.15-.14v-1.5zM1.44 7.88a.15.15 0 00-.14-.15H.64a.15.15 0 00-.14.15V9.4c0 .15.1.28.21.28h3.48v-.9H1.44z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82 8.32a.11.11 0 01-.11.12h-1a.11.11 0 01-.13-.11v-.77a.11.11 0 01.11-.13h1c.1 0 .15.05.15.13zm0 .76C7.82 9 7.77 9 7.67 9h-1a.12.12 0 00-.11.13v.78a.12.12 0 00.13.11h1a.12.12 0 00.11-.13zm0 1.52c0-.07-.05-.12-.15-.12h-1a.11.11 0 00-.11.12v.78a.11.11 0 00.13.11h1a.11.11 0 00.11-.13zm-4.2-6.49A.13.13 0 003.47 4h-1a.12.12 0 00-.11.13v.78a.12.12 0 00.11.09h1a.11.11 0 00.11-.13zm0 1.52c0-.07-.05-.12-.15-.12h-1a.11.11 0 00-.11.12v.77a.11.11 0 00.12.11h1a.11.11 0 00.11-.12zm0 1.53c0-.08-.05-.13-.15-.13h-1a.12.12 0 00-.11.13v.76a.12.12 0 00.12.12h1a.12.12 0 00.11-.13z",
    fill: "#76bc2d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureEventsHub);
export default __webpack_public_path__ + "static/media/azure-eventsHub.d689ff2eb54a61a07cd18dd80fa4fd69.svg";
export { ForwardRef as ReactComponent };